<template>
  <div class="panel">
      <div class="panel-heading">
        <div class="panel-label">
          <h3> Select shop </h3>
        </div>
      </div>
      <div class="panel-body">
        <div class="alert alert-secondary">
            <div class="alert-text"> Here is option to copy shop from your defined list to create new shop </div>
        </div>
        <div class="col-xs-12">
          <shop-picker :shop.sync="selectedShop" :shops="shops"></shop-picker>
        </div>
      </div>
      <div class="panel-footer">
        <button v-on:click="use" type="button" class="btn-info btn btn-xs">USE</button>
        <button v-on:click="clear" type="button" class="btn-danger btn btn-xs">CLEAR</button>
      </div>
  </div>
</template>

<script type="text/babel">
import ShopPicker from '@/components/Panel/Account/ShopPicker.vue';

import { mapActions } from 'vuex';

export default {
    name: 'Copier',
    components: { ShopPicker },
    data (){
        return {
            selectedShop: {},
            shops: []
        };
    },
    props: ['selected'],
    methods:{
        ...mapActions([
          'GetShopsAll'
        ]),
        use (){
            this.$store.commit('currentShop', {});
            this.$emit('selected', this.selectedShop);
        },
        clear (){
            this.$emit('selected', {});
        }
    },
    async mounted () {
      this.shops = await this.GetShopsAll({ });
    }
};
</script>

<style lang="scss">

</style>
